import { render } from "./App.vue?vue&type=template&id=3ac30124"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3ac30124&lang=scss"

import exportComponent from "E:\\Project\\one-code-pass\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__